<template>
  <div v-if="positions.length" class="missing-position-warning alert alert-warning py-1 px-2 mb-1 small">
    <div v-for="position in positions" :key="position">
      <i class="fa fa-exclamation-triangle mr-1"></i>
      <b v-if="team">{{ team }}: </b>{{ $t('game.position_missing_warning', { position }) }}
    </div>
  </div>
</template>

<script>
export default {
  props: {
    // Names of the positions (e.g. GK) that nobody holds
    positions: {
      type: Array,
      default: () => []
    },
    // Shown in front of the text where the team is not obvious (the substitution dialog)
    team: {
      type: String,
      default: ''
    }
  }
}
</script>
